module.exports = __webpack_public_path__ + "static/media/editvr-logo.bc4c9331.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/editvr-logo.svg
// module id = 251
// module chunks = 0